import React from "react";
import UploadSection from "./UploadSection";
import "styles/legacy/UploadNewTitle.css";
import "./VrMediaVerification.css";

type UploadStage = "idle" | "uploading" | "uploaded" | "error";

interface Props {
  file: File | null;
  onChange: (file: File | null) => void;
  uploadStage: UploadStage;
  progress: number;
  onCancel: () => void;
  onDelete?: () => void;
  isInvalid?: boolean;
  isEditingPublished?: boolean;
  /** Rendered under the upload box (e.g. VR verification + transcoding status). */
  children?: React.ReactNode;
}

const MainVideoUpload: React.FC<Props> = ({
  file,
  onChange,
  uploadStage,
  progress,
  onCancel,
  onDelete,
  isInvalid = false,
  isEditingPublished = false,
  children,
}) => {
  return (
    <div className="upload-section-group">
      <UploadSection
        title="Main video file*"
        description="Once approved, this video file will be encoded"
        formats="MP4, MKV, WEBM, MOV (40GB max.)"
        onFileChange={onChange}
        currentFile={file}
        accept="video/*"
        uploadStage={uploadStage}
        progress={progress}
        onCancel={onCancel}
        onDelete={onDelete}
        isInvalid={isInvalid}
        isEditingPublished={isEditingPublished}
      />
      {children}
    </div>
  );
};

export default MainVideoUpload;
